window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.TextSamplesSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// OpenSans copy
	this.os30 = new cjs.Text("Font ", "30px 'Open Sans'", "#0000FF");
	this.os30.name = "os30";
	this.os30.lineHeight = 41;
	this.os30.lineWidth = 93;
	this.os30.parent = this;
	this.os30.setTransform(97.0953,89.2);
ranj.TextOffsetFixer.fix(this.os30);

	this.timeline.addTween(cjs.Tween.get(this.os30).wait(1));

	// OpenSans copy 2
	this.os90 = new cjs.Text("Font", "90px 'Open Sans'", "#00FF00");
	this.os90.name = "os90";
	this.os90.lineHeight = 123;
	this.os90.lineWidth = 308;
	this.os90.parent = this;
	this.os90.setTransform(91.3,67.9);
ranj.TextOffsetFixer.fix(this.os90);

	this.timeline.addTween(cjs.Tween.get(this.os90).wait(1));

	// OpenSans
	this.os60 = new cjs.Text("Font ", "60px 'Open Sans'");
	this.os60.name = "os60";
	this.os60.lineHeight = 82;
	this.os60.lineWidth = 282;
	this.os60.parent = this;
	this.os60.setTransform(94.2453,78.65);
ranj.TextOffsetFixer.fix(this.os60);

	this.timeline.addTween(cjs.Tween.get(this.os60).wait(1));

	// OpenSans copy 4
	this.os120 = new cjs.Text("Font", "120px 'Open Sans'", "#FF0000");
	this.os120.name = "os120";
	this.os120.lineHeight = 163;
	this.os120.lineWidth = 353;
	this.os120.parent = this;
	this.os120.setTransform(88.25,57.3);
ranj.TextOffsetFixer.fix(this.os120);

	this.timeline.addTween(cjs.Tween.get(this.os120).wait(1));

	// OpenSans copy 3
	this.os150 = new cjs.Text("Font", "150px 'Open Sans'", "#FF00FF");
	this.os150.name = "os150";
	this.os150.lineHeight = 204;
	this.os150.lineWidth = 353;
	this.os150.parent = this;
	this.os150.setTransform(85.45,46.9);
ranj.TextOffsetFixer.fix(this.os150);

	this.timeline.addTween(cjs.Tween.get(this.os150).wait(1));

	// guide 
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0000FF").ss(1,1,1,3,true).p("AH0AAIn0AAIAAH0AAAAAInzAAAAAnzIAAHz");
	this.shape.setTransform(100,100);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TextSamplesSkin, new cjs.Rectangle(49,44.9,1293.4,867.3000000000001), null);


// stage content:
(lib.TextPositioningAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// TextSamplesSkin
	this.instance = new lib.TextSamplesSkin();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(1010,584.9,-566.8,-331.7);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#999999",
	opacity: 1.00,
	manifest: [],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.TextPositioningAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.TextPositioningAssets;